/**
This tooltip module is designed to work only .lendingtree.com domain. For other domain, please disable the same.
*/
<template>
    <span>
        <modal
            v-if="ShowModal"
            class="insurance-zip-modal">
            <div
                slot="body"
                class="insurance-zip-modal">
                <h3 v-html="PopupTitle"></h3>
                <div class="row question-block">
                    <div class="col-xs-12 col-sm-6">
                        <h4 class="question">What's your ZIP code?</h4>
                        <span class="gray-text">We'll use your location to find <span class="line-br"></span>providers in your area</span>
                        <div class="form-group">
                            <zip-code-input
                                v-model="ZipCode"
                                :autofocus="true"
                                @input="getLocationByZip"
                                @enter="submit(ZipCode, CurrentlyInsured)"
                            />
                            <div>
                                <span
                                    v-show="ShowZipCodeError"
                                    class="error-msg">Please enter a valid zip code.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <h4 class="question">Do you currently have insurance?</h4>
                        <span class="gray-text">Insurance companies like to know if you're switching <span class="line-br"></span>from someone else</span>
                        <ul class="form-radio">
                            <li>
                                <input
                                    id="insurance-yes"
                                    v-model="CurrentlyInsured"
                                    type="radio"
                                    name="insurance-insured"
                                    :value="true"
                                    @click="resetInsuranceError(true)"
                                /> <label for="insurance-yes">Yes</label>
                            </li>
                            <li>
                                <input
                                    id="insurance-no"
                                    v-model="CurrentlyInsured"
                                    type="radio"
                                    name="insurance-insured"
                                    :value="false"
                                    @click="resetInsuranceError(false)"
                                /> <label for="insurance-no">No</label>
                            </li>
                        </ul>
                        <div>
                            <span
                                v-show="ShowInsuredError"
                                class="error-msg">Please select an option.</span>
                        </div>
                    </div>
                </div>
                <div class="clear-fix"></div>
                <button
                    class="btn btn-blue"
                    @click="submit(ZipCode, CurrentlyInsured)">Get Started</button>
            </div>
        </modal>
    </span>
</template>

<script>
    import Modal from '~/components/modal.vue';
    import GetLocation from '~/mixin/get-geo-location';
    import ZipCodeInput from '~/components/zip-code-input.vue';

    export default {
        components: {
            Modal,
            ZipCodeInput,
        },
        mixins: [GetLocation],
        props: {
            zipCode: {
                default: '',
            },
            currentlyInsured: {
                default: null,
            },
            showModal: {
                default: false,
            },
            popupTitle: {
                default: 'Just two quick questions before we get your quotes.',
            },
        },
        data() {
            return {
                CurrentlyInsured: this.currentlyInsured,
                ShowInsuredError: false,
                ShowModal: true,
                ShowZipCodeError: false,
                ZipCode: this.zipCode,
                ZipError: this.false,
                City: '',
                State: '',
                PopupTitle: this.popupTitle,
            };
        },
        mounted() {
            this.ShowModal = this.showModal;
        },
        methods: {
            submit(zip, insured) {
                this.ZipCode = zip;
                this.CurrentlyInsured = insured;
                this.ShowZipCodeError = !this.zipCodeValidator();
                this.ShowInsuredError = !this.checkInsuranceStatus();
                if (!this.ShowZipCodeError && !this.ShowInsuredError) {
                    this.ShowModal = false;
                    this.$emit('submit', {
                        zipCode: this.ZipCode, insured: this.CurrentlyInsured, city: this.City, state: this.State,
                    });
                }
            },
            getLocationByZip() {
                this.ShowZipCodeError = false;
                this.ZipError = false;
                if (this.zipCodeValidator()) {
                    GetLocation.methods.GetZipCode(this.ZipCode, this.updateLocation);
                }
            },
            updateLocation(val) {
                this.ZipCode = val.zipCode;
                this.ZipError = val.err;
                if (this.ZipError) {
                    this.ShowZipCodeError = true;
                    this.ZipCode = '';
                } else {
                    this.ShowZipCodeError = false;
                    this.City = val.city;
                    this.State = val.state;
                }
            },
            zipCodeValidator() {
                const zipRegEx = /^\d{5}$/;
                const testZip = zipRegEx.test(this.ZipCode) && this.ZipCode !== '';
                return testZip && !this.ZipError;
            },
            checkInsuranceStatus() {
                return this.CurrentlyInsured != null;
            },
            resetInsuranceError(val) {
                this.CurrentlyInsured = val;
                this.ShowInsuredError = false;
            },
        },
    };
</script>

<style lang="scss">
@import "../../../assets/styles/variables";

#lt-yantr {
    .insurance-zip-modal {
        text-align: center;
        padding: 30px 0;

        @media #{$mob-landscape-view} {
            padding: 25px 0 20px;
        }

        @media #{$mob-portrait-view} {
            padding: 0;
        }

        .modal-wrapper {
            max-width: 900px;
        }

        .modal-close {
            margin-top: 0;
        }

        h3 {

            @media #{$mob-landscape-view} {
                font-size: 20px;
                padding: 0 20px;
            }
        }
        .question-block {
            font-size: 15px;
            margin: 50px 0;

            @media #{$mob-landscape-view} {
                margin: 25px 0;
            }

            .btn {
                font-size: 15px;
            }
        }

        .question {
            color: #101f30;
            font-weight: 600;
            display: block;
            margin-bottom: 5px;

            @media #{$mob-portrait-view} {
                font-size: 17px;
                line-height: normal;
            }
        }

        .line-br {
            display: block;

            @media #{$mob-portrait-view} {
                display: inline-block;
            }
        }

        .form-group {
            max-width: 300px;
            margin: 15px auto 0;

            @media #{$mob-landscape-view} {
                margin-bottom: 20px;
            }

            input {
                text-align: center;
                max-width: 120px;
                height: 40px;
                line-height: 40px;
                margin-bottom: 10px;
            }
        }

        .form-radio li {
            color: #101f30;
            font-size: 17px;
            display: inline-block;
            margin: 20px 10px 0;

            [type="radio"]:checked + label, [type="radio"]:not(:checked) + label {
                font-weight: 600;
                padding-left: 30px;
            }
        }

        .btn {
            padding: .4em 3em;
        }

        .modal-close {
            display: none;
        }
    }
}
</style>
